const React = require('react');
const ReceiveALL = require('./receive-all.jsx');
const StandardAddrSelectSearchBox = require('../mui/standard-addrselect/standard-addrselect-searchbox.jsx');
const getUrlParam = require('../../helper/dish-helper.js').getUrlParam;
import FormattedMessage from '@/intl/formatted-message';
import shopText from '../../intl/messages/shop';
const shopId = getUrlParam('shopId');
const brandId = getUrlParam('brandId');
const noDataImageUrl = require('../../asset/images/shoplist-no-data.svg');
const BMap = window.BMap;

require('./shop-choose-address.scss');
require('../mui/standard-addrselect/standard-addrselect.scss');

const shopChooseAddress = React.createClass({
  displayName: 'shopChooseAddress',
  propTypes: {
    mineAddressList: React.PropTypes.array,
    cityList: React.PropTypes.array,
    curPosition: React.PropTypes.object,
    curAddressOk: React.PropTypes.bool,
    getMineAddressList: React.PropTypes.func,
    setLoadMsg: React.PropTypes.func,
    refreshAddress: React.PropTypes.func,
  },

  getInitialState() {
    return {
      isSpand: false,
      suggestList: [],
      suggestVisible: false,
      city: '北京',
    };
  },

  componentDidMount() {
    const that = this;
    const local = (this._mapLocal = new BMap.LocalSearch(new BMap.Point(116.404, 39.915), {
      pageCapacity: 20,
      onSearchComplete(results) {
        if (local.getStatus() === window.BMAP_STATUS_SUCCESS) {
          const pois = [];
          for (let i = 0; i < results.getCurrentNumPois(); i++) {
            const poi = results.getPoi(i);
            pois.push({
              title: poi.title,
              address: poi.address,
              point: poi.point,
              uid: poi.uid,
            });
          }
          that.setState({ suggestList: pois, suggestVisible: true });
        } else {
          that.setState({ suggestVisible: true });
        }
      },
    }));
  },

  componentWillUnmount() {
    this._mapLocal = this._map = null;
  },

  getCurrentCity(city) {
    if (city) {
      this.setState({ city: city.replace(/市$/, '') });
    }
  },

  goBackToList(e) {
    e.preventDefault();
    const { refreshAddress } = this.props;
    window.chosenAddress = '';
    location.hash = '';
    refreshAddress(e);
  },

  handleUserInput(searchKey) {
    if (this.timer) {
      window.clearTimeout(this.timer);
    }

    this.setState({ searchKey, suggestList: [], showCityChangeList: false });

    if (!searchKey) {
      this.setState({ suggestList: [], suggestVisible: false });
      return;
    }

    this.timer = window.setTimeout(x => {
      if (this._mapLocal) {
        const { city } = this.state;
        this._mapLocal.setLocation(city);
        this._mapLocal.search(searchKey, { forceLocal: true });
      }
    }, 500);
  },

  cityChange(obj = {}) {
    this.setState({ city: obj.name, suggestList: [], suggestVisible: false, showCityChangeList: false });
  },

  handleSuggestVisible(visible) {
    let _visible = visible;

    if (_visible === undefined) {
      _visible = !this.state.suggestVisible;
    }

    this.setState({ suggestVisible: _visible });
  },

  selectComplete(obj = {}) {
    window.chosenAddress = {
      brandId,
      uniqueId: 'WM',
      shopId,
      latitude: `${obj.point.latitude}`,
      longitude: `${obj.point.longitude}`,
      isGetLoc: true,
      address: `${obj.title}：${obj.address}`,
    };

    sessionStorage.removeItem('receiveOrderCustomerInfo');
    location.hash = '';
  },

  triggerCityChange() {
    this.setState({ showCityChangeList: true, suggestVisible: false, searchKey: '' });
  },

  handleShowCityChangeList() {
    this.setState({ showCityChangeList: true, suggestVisible: false, searchKey: '' });
  },

  render() {
    const { city, suggestList = [], suggestVisible, searchKey, showCityChangeList } = this.state;
    const { mineAddressList, getMineAddressList, curPosition, curAddressOk, setLoadMsg } = this.props;
    const currentCity = { name: city ? `${city}市` : '' };

    return (
      <div className="select-address" ref="select_address">
        <div className="input-row">
          <StandardAddrSelectSearchBox
            onCurrentCityChange={this.cityChange}
            currentCity={currentCity}
            onSetSuggestVisible={this.handleSuggestVisible}
            suggestVisible={suggestVisible}
            onSelectComplete={this.selectComplete}
            onUserInput={this.handleUserInput}
            suggest={suggestList}
            showCityChangeList={showCityChangeList}
            onShowCityChangeList={this.handleShowCityChangeList}
            notFindCityButton={'notFindCityButton'}
            triggerCityChange={this.triggerCityChange}
          />
          {suggestList.length === 0 && searchKey && suggestVisible && (
            <div className="noSuggestList">
              <img src={noDataImageUrl} alt="没有数据" className="noDataImage" />
              <span className="locate-fail">
                <FormattedMessage {...shopText.shopnotSearchAddressPrompt} />
                <br />
                <a href=" javascript:void(0)" className="switch-city" onTouchTap={this.triggerCityChange}>
                  <FormattedMessage {...shopText.shopclickToChangeCity} />
                </a>
              </span>
            </div>
          )}
        </div>
        <div className="relocate-outer">
          <div className="relocate" onTouchTap={this.goBackToList}>
            <i className="relocate-icon"></i>
            <FormattedMessage {...shopText.shopclickToLocate} />
          </div>
          <ReceiveALL
            getMineAddressList={getMineAddressList}
            mineAddressList={mineAddressList}
            curPosition={curPosition}
            curAddressOk={curAddressOk}
            getCurrentCity={this.getCurrentCity}
            setLoadMsg={setLoadMsg}
          />
        </div>
      </div>
    );
  },
});

module.exports = shopChooseAddress;



// WEBPACK FOOTER //
// ./src/component/shop-list/shop-choose-address.jsx